exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-label:after{left:0;right:auto;border-left-width:0;border-right:inherit}.preview-table__label{padding:.5rem 1.5rem .3rem;margin:0;border-bottom:1px solid rgba(0,0,0,.125);background:rgba(0,0,0,.03);font-weight:700}", ""]);

// exports
